export default {
  methods: {
    oldApps_showToolpathViewer(fileId, fileName) {
      window.toolpathViewer.showPopup();
      window.toolpathViewer.startLoad(fileId);
      document.querySelector('#toolpath-viewer_popup h1 .fili-name').textContent = fileName;
    },
    oldApps_showStlEditor(fileId, fileName) {
      window.stlEditor.showPopup();
      window.stlEditor.startLoad(fileId);
      document.querySelector('#stl_editor3d_popup h1 .fili-name').textContent = fileName;
    },
    oldApps_showCloudSlicer(fileId, printerTypeId, mode, filename) {
      window.slicer.openSlicer(fileId, printerTypeId, mode, filename);
    },
    oldApps_showCloudMbotSlicer(fileId, printerTypeId, mode, filename) {
      window.mbotslicer.open(fileId, mode, printerTypeId, filename);
    },
    slicerNameById(appId) {
      switch (parseInt(appId)) {
        case 3: return 'Cloud Slicer';
        case 48: return 'Slicer for Makerbot';
        case 51: return 'Slicer3';
        default: return 'Unknown slicer';
      }
    }
  }
}
